export enum EWidgetGridSize {
  GRID_25_75 = '25%/75%',
  GRID_33_66 = '33%/66%',
  GRID_50_50 = '50%/50%',
  GRID_66_33 = '66%/33%',
  GRID_75_25 = '75%/25%',
  GRID_33_33_33 = '33%/33%/33%',
  GRID_100 = '100%',
}
